<template>
  <div class="main-box" v-loader.opacity="loading">
    <div class="no-results-box" v-if="alert.message">
      <BaseNoResults :title="alert.title" :text="alert.message"/>
    </div>

    <BaseTable class="no-border" v-if="tableUsers.items?.length" :tabledata="tableUsers" @item-opened="toDetails">
      <template  v-slot:column_security="{item}">
        <span class="label" :class="mfaStatus(item)">
          MFA
        </span>
      </template>

      <template v-slot:column_permissions="{item}">
        <span class="label" :class="getPermissionClass(item)">
          {{ $t(item.permissions) }}
        </span>
      </template>
    </BaseTable>

    <UserInvitationOffcanvas :offcanvas_id="'userInvitationOffcanvas'" ref="userInvitationOffcanvas"/>

    <teleport :to="`#${slotPagination}`" v-if="isDataReady">
      <div v-if="tableUsers" class="align-items-center pagination-row">
        <p class="pagination-total">{{ `${tableUsers.total} ${$t("pagination.users")}` }}</p>
          <BasePagination :total-pages="totalPages" :total="tableUsers.total" :is-loading="loading"
                          :per-page="perPage" :current-page="currentPage" @pagechanged="onPageChange"/>
      </div>
    </teleport>

    <teleport to="#settingsActionBar" v-if="isDataReady">
      <button class="btn btn-success" type="button" name="button" data-test="btnOpenModalInvitation" @click="openModalInvitation">
        {{ $t('user.invite') }}
      </button>
    </teleport>
  </div>
</template>

<style lang="scss" scoped>
  .main-box {
    padding:                               10px;
  }

  .title-box,
  .title-box .btn,
  .vtable > tbody > tr > td .btn.btn-danger.btn-sm {
    margin-bottom:                         0;
  }

  .vtable {
    > tbody > tr > td {
      span.label-warning {
        text-transform:                    uppercase;
        vertical-align:                    middle;
      }
      .btn.btn-danger.btn-sm {
        line-height:                       1;
      }
      &:first-child {
        span {
          text-transform:                  capitalize;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .main-box {
      overflow:                            hidden;
    }
  }

  @media (max-width: 767px) {
    .main-box .alert {
      margin:                              0 5px;
    }
  }

  @media (min-width: 768px) {
    .main-box .alert {
      margin:                              0 15px;
    }
  }

  @media (max-width: 991px) {
    .main-box,
    .no-results-box {
      height:                              100%;
      text-align:                          center;
    }
  }
</style>

<script>
import { useUserStore } from '@/store/user'
import UserInvitationOffcanvas from './UserInvitationOffcanvas.vue'

export default {
  name: 'UsersList',
  components: {
    UserInvitationOffcanvas,
  },
  data: () => ({
    loading: false,
    alert: {
      title: null,
      message: null,
      class: null
    },
    session: {
      collaborator: {},
      currentClinic: {}
    },
    tableUsers: {
      items: [],
      total: 0,
      columns: []
    },
    perPage: 20,
    currentPage: 1,
    totalPages: 0,
    showModalInvitation: false,
    isDataReady: false,
    slotPagination: 'settingsPagination',
  }),
  async mounted() {
    this.$activeLink.value = 'users'
    const userStore = useUserStore()
    this.session = userStore.sessionInfo
    this.fetchData();

    this.handleResize()
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    mfaStatus(user) {
      return this.$userService.mfaStatus(user)
    },
    onPageChange(page) {
      this.currentPage = page;
      this.fetchData();
    },
    async fetchData() {
      this.alert = {}
      let params = {
        page: this.currentPage,
      }

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$userService.list(params);

        let hideMFA = !this.session.isPowerfull // TODO retrieve from clinic.security.mfaMode [optional or mandatory]

        this.tableUsers = {
          'items': response.result,
          'total': response.totalCount,
          //'total': response.result.length,
          'columns': [
            {name: this.$i18n.t('user.name'), type: 'string', value: 'collaborator.rawName', width: '20%'},
            {name: this.$i18n.t('user.email'), type: 'string', value: 'email', width: '20%'},
            {name: this.$i18n.t('user.document'), type: 'string', value: 'collaborator.document', width: '20%', align: 'text-center'},
            {key: 'permissions', name: this.$i18n.t('user.permissions'), type: 'custom', value: 'permissions', width: '20%', align: 'text-center'},
            {key: 'security', hide: hideMFA, name: this.$i18n.t('user.security'), type: 'custom', value: 'security', width: '20%', align: 'text-center'},
            // {key: 'actions', name: this.$i18n.t('user.administration'), type: 'custom', value: 'actions', width: '10%', align: 'text-center'},
          ]
        };
        //this.totalPages = Math.ceil(response.result.length / this.perPage);
         this.totalPages = Math.ceil(response.totalCount / this.perPage);

        if (response.result.length === 0) {
          this.tableUsers = {};
          this.alert = this.$message.alertWithTitle(this, 'request_notfound_user_title', 'request_notfound_user_text')
          // this.$message.popup(this, 'request_notfound', 'operationWarning', 'warn')
        }
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      } finally {
        NProgress.done(true)
        this.loading = false
        this.isDataReady = true
      }
    },
    toDetails(values) {
      if (!values) {
        return
      }
      let item = values.item
      if (!item) {
        return
      }
      this.$router.push({name: 'user-show', params: {userID: item.id}, query: {tab: 'data'}})
    },
    async openModalInvitation() {
      const ok = await this.$refs.userInvitationOffcanvas.show({
        title: this.$i18n.t('user.inviteCollaborator'),
        okButton: this.$i18n.t('user.send'),
        okButtonClass: 'btn-success',
      })
      if (ok) {
        // eslint-disable-next-line no-console
        console.log('the invitation has been sent');
        // this.$router.push({name: 'patient-create', params: {patientID: ''}})
      }
    },
    setAlert(val) {
      this.alert = {
        message: val.message,
        class: val.class
      };
    },
    getPermissionClass(item) {
      if (item.permissions == 'admin') {
        return 'label-blue'
      } else if (item.permissions == 'physician') {
        return 'label-green'
      } else if (item.permissions == 'technician') {
        return 'label-purple'
      } else if (item.permissions == 'specialist') {
        return 'label-warning'
      } else {
        return 'label-pink'
      }
    },
    handleResize() {
      this.slotPagination = window.innerWidth > 767 ? 'settingsPagination' : 'settingsPaginationMobile'
    },
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>
